export default __webpack_public_path__ + "static/media/image 36.f972a485.png";